import {Component, OnInit} from "@angular/core";
import {UserService} from "../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiService} from "../../../services/api.service";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false
})
export class DashboardComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    { label: 'Home', path: 'https://www.scalanthropy.com/'},
    { label: 'Dashboard', path: 'app/users/dashboard'}
  ];
  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  isConsultant: string = 'N';
  subscriptionActive: boolean = false;
  pilotTrialVerified: boolean = false;
  customerTrialVerified: boolean = false;

  showPageSubscriptionMessages: boolean = false;
  subscriptionMessages: any[] = [];
  emailCodeVerifiedFlag: string = 'N';

  blogs: any[] = [];
  firstRowBlogs: any[] = [];
  secondRowBlogs: any[] = [];
  guides: any[] = [];
  firstRowGuides: any[] = [];
  secRowGuides: any[] = [];
  tutorials: any[] = [];
  videos: any[] = [];
  sideMenuOpened: boolean = true;
  accountsVisible: boolean = false;

  users: any[] = [];

  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService: UserService,
              private routerChild: Router, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Dashboard")
  }

  ngOnInit(): void {
    //verify subscription
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.pageSuccessMessages = [];
    this.pageErrorMessages = [];
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    this.isConsultant = this.auth2ServiceChild.getIsConsultant();
    this.emailCodeVerifiedFlag = this.auth2ServiceChild.getEmailCodeVerifiedFlag()
    if (this.emailCodeVerifiedFlag != 'Y') {
      this.routerChild.navigateByUrl('app/users/emails/verify')
      return;
    } else {
      this.userService.getBlogs(this.username).subscribe((resultBlogs: any) => {
          if (resultBlogs && resultBlogs.body) {
            this.blogs = resultBlogs.body
            this.firstRowBlogs = this.blogs.slice(0, 3);
            this.secondRowBlogs = this.blogs.slice(3, 6);
            const firstRowBlogsLength: number = this.firstRowBlogs.length;
            let i: number = 0;
            while (i < firstRowBlogsLength) {
              if (this.firstRowBlogs[i]['displayName'] && this.firstRowBlogs[i]['displayName'].length > 70) {
                this.firstRowBlogs[i]['displayName'] = this.firstRowBlogs[i]['displayName'].substring(0, 70) + '...';
              }
              i = i + 1;
            }
            const secRowBlogsLength: number = this.secondRowBlogs.length;
            let j: number = 0;
            while (j < secRowBlogsLength) {
              if (this.secondRowBlogs[j]['displayName'] && this.secondRowBlogs[j]['displayName'].length > 70) {
                this.secondRowBlogs[j]['displayName'] = this.secondRowBlogs[j]['displayName'].substring(0, 70) + '...';
              }
              j = j + 1;
            }
          }
        }, (errorBlogs: HttpErrorResponse) => {
          this.pageErrorMessages.push({
            field: 'Blogs Error',
            detail: 'Failed to fetch the Blogs. Please refresh the page....',
            severity: 'severity'
          });
          this.showErrorMessagesToUser();
        }
      );
      this.userService.getGuides(this.username).subscribe((resultGuides: any) => {
          if (resultGuides && resultGuides.body) {
            this.guides = resultGuides.body
            this.firstRowGuides = this.guides.slice(0, 3);
            this.secRowGuides = this.guides.slice(3, 4);
            const firstRowGuidesLength: number = this.firstRowGuides.length;
            let z: number = 0;
            while (z < firstRowGuidesLength) {
              if (this.firstRowGuides[z]['displayName'] && this.firstRowGuides[z]['displayName'].length > 70) {
                this.firstRowGuides[z]['displayName'] = this.firstRowGuides[z]['displayName'].substring(0, 70) + '...';
              }
              z = z + 1;
            }
            const secRowGuidesLength: number = this.secRowGuides.length;
            z = 0;
            while (z < secRowGuidesLength) {
              if (this.secRowGuides[z]['displayName'] && this.secRowGuides[z]['displayName'].length > 70) {
                this.secRowGuides[z]['displayName'] = this.secRowGuides[z]['displayName'].substring(0, 70) + '...';
              }
              z = z + 1;
            }
          }
        }, (errorGuides: HttpErrorResponse) => {
          this.pageErrorMessages.push({
            field: 'Guides Error',
            detail: 'Failed to fetch the Guides. Please refresh the page....',
            severity: 'severity'
          });
          this.showErrorMessagesToUser();
        }
      );
      // @ts-ignore
      this.userService.getSubscriptionVerification(this.username).subscribe((result: any) => {
        if (result && result.body) {
          this.subscriptionActive = result.body.verified;
          this.pilotTrialVerified = result.body.pilotTrialVerified;
          this.customerTrialVerified = result.body.customerTrialVerified;
          if (this.subscriptionActive) {
            this.pageSuccessMessages.push({
              field: 'Subscription Successfully Verified',
              detail: 'Subscription has been successfully verified.',
              severity: 'success'
            });
            this.showPageSuccessMessagesToUser();

            //Only fetch Users if it is the user is consultant
            if (this.isConsultant == 'Y') {
              this.userService.getAllUsersAssociatedWithConsultant(this.username).subscribe(
                (usersResult: any) => {
                  if (usersResult && usersResult.body) {
                    this.users = usersResult.body;
                  }
                }, (errorResponse: HttpErrorResponse) => {
                  this.pageErrorMessages.push({
                    field: 'Failed to fetch the Consultants Users',
                    detail: 'Failed to fetch the Consultants Users. Please refresh the page....',
                    severity: 'severity'
                  });
                  this.showErrorMessagesToUser();
                }
              )
            }
          } else {
            this.subscriptionMessages.push({
              field: 'Subscription is now Inactive',
              detail: 'Click here to renew your subscription.',
              link: 'app/users/dashboard/subscription/pricing/pay',
              severity: 'severity'
            });
            this.showPageSubscriptionMessages = true;
          }
        }
      }, (error: HttpErrorResponse) => {
        console.log(JSON.stringify(error))
        this.pageErrorMessages.push({
          field: 'Subscription verification error',
          detail: 'Subscription could not be verified due to a generic error....',
          severity: 'severity'
        });
        this.showErrorMessagesToUser();
        this.redirectToLogin(error);
      });
    }
  }

  toggleSideMenu() {
    this.sideMenuOpened = !this.sideMenuOpened;
  }

  toggleAccountsVisible(): void {
    this.accountsVisible = !this.accountsVisible;
  }

  openNav() {
    /*
    // @ts-ignore
    const element = document.getElementById("myAccountSidenav");
    if (element) {
      element.style.width = "400px"
      // @ts-ignore
      element.style['padding-left'] = "20px";
      this.isAccountSideNavOpened = true;
    }*/
  }

  /* Set the width of the side navigation to 0 */
  closeNav() {
    /*
    // @ts-ignore
    const element = document.getElementById("myAccountSidenav");
    if (element) {
      element.style.width = "0";
      // @ts-ignore
      element.style['padding-left'] = "0px";
      this.isAccountSideNavOpened = false;
    }*/
  }

  navToChangePasswordPage(): void {
    if (this.detectImpersonation()) {
      return;
    }
    this.routerChild.navigateByUrl('app/users/dashboard/users/change-password');
  }

  navToGeneralFeedbackPage(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/wishlist-home');
  }

  private detectImpersonation(): boolean {
    return (this.username != null) && (this.impersonatedEmail != null) &&
      (this.username != this.impersonatedEmail)
  }

  navToUserProfilePage(): void {
    localStorage.setItem('redirectUrl', 'app/users/dashboard');
    if (this.detectImpersonation()) {
      return;
    }
    const isConsultant: string = this.auth2ServiceChild.getIsConsultant();
    if (isConsultant == 'Y') {
      this.routerChild.navigateByUrl('app/consultants/users/edit');
    } else {
      this.routerChild.navigateByUrl('app/users/edit');
    }
  }

  navToSubscriptionRenewalPage(): void {
    localStorage.setItem('redirectUrl', 'app/users/dashboard');
    if (this.detectImpersonation()) {
      return;
    }
    this.routerChild.navigateByUrl('app/users/dashboard/subscription/pricing/pay');
  }

  navToSearchNonprofitsPage(): void {
    this.routerChild.navigateByUrl('app/search/nonprofits');
  }

  navToSearchDonorsPage(): void {
    this.routerChild.navigateByUrl('app/search/donors');
  }

  navToSearchGrantsPage(): void {
    this.routerChild.navigateByUrl('app/search/grants');
  }

  navToFundingGoalsPage(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/funding-goals/all');
  }

  navToSavedSearchesPage(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
  }

  navToSubscriptionsPage(): void {
    if (this.detectImpersonation()) {
      return;
    }
    this.routerChild.navigateByUrl('app/users/dashboard/subscription');
  }

  navToAllPaymentCardsPage(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/payment-cards/all');
  }

  navToWebpage(url: string): void {
    // @ts-ignore
    window.open(url, '_blank').focus();
}

  navToDashboard(userDto: any): void {
    //Record the impersonated account username in the cache if the consultant select a client account instead
    console.log("userDto.email: " + userDto.email);
    console.log("userDto.isConsultant: " + this.users[0].isConsultant);
    console.log("userDto.consultantReferralCodeVerified: " + userDto.consultantReferralCodeVerified);
    console.log("userDto.consultantRoleName: " + userDto.consultantRoleName);
    if (this.username != userDto.email &&
      this.auth2ServiceChild.getIsConsultant() == 'Y' &&
      userDto.consultantReferralCodeVerified == 'Y'
    ) {
      this.auth2ServiceChild.setImpersonatedEmail(userDto.email);
      this.auth2ServiceChild.setConsultantRoleName(userDto.consultantRoleName);
    } else {
      this.auth2ServiceChild.removeImpersonatedEmail();
      this.auth2ServiceChild.removeConsultantRoleName();
    }
    window.location.reload();
  }
}
